(($) => {

    $.fn.snap = function () {

        const scrollDuration = 300;
        //Break point
        const BP =1200;
        $(this).each((i, node) => {

            const el = $(node);
            const list = el.find('.snap-list');
            const prev = el.find('.snap-prev');
            const next = el.find('.snap-next');
            const items = list.find('.snap-item');
            let autoscrolling = false;
            let timeoutId;
            if ($(window).width() < BP ) {
                startCaroucel();
            }else{
                stopCarousel();
            }
            $(window).resize(function() {
                if ( $(window).width() < BP ) {
                    startCaroucel();
                } else {
                    stopCarousel();
                }
            });

            function startCaroucel(){
                const nextPrevBtns = $('.arrow-sign');
                nextPrevBtns.removeClass('off');
            }
            function stopCarousel() {
                let nextPrevBtns = $('.arrow-sign');
                if(items.length <= 6) {
                    nextPrevBtns.addClass('off');
                }else{
                    nextPrevBtns.removeClass('off');
                }
              }

            updateNavigation();
            prev.on('click', event => {
                if (!autoscrolling) {
                    const n = getSnapIndex() - 1;
                    if (n >= 0) {
                        setSnapIndex(n);
                    }
                }
            });

            next.on('click', event => {
                console.log('next')
                if (!autoscrolling) {
                    const n = getSnapIndex() + 1;
                    const max = maxSnapIndex();
                    if (n <= max) {
                        setSnapIndex(n);
                    }
                }
            });

            list.on('scroll', event => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(() => {
                    updateNavigation();
                }, 100);
            });

            function setSnapIndex(index) {
                const item = items.eq(index);
                if (item.length > 0) {
                    const listLeft = list[0].getBoundingClientRect().left;
                    const itemLeft = item[0].getBoundingClientRect().left;
                    const itemRelativeLeft = itemLeft - listLeft;
                    scrollList(`+=${itemRelativeLeft}`);
                }
            }

            function scrollList(scrollLeft) {
                autoscrolling = true;
                list.animate({
                    scrollLeft: scrollLeft,
                }, scrollDuration, () => {
                    autoscrolling = false;
                });
            }

            function updateNavigation() {
                const index = getSnapIndex();
                const max = maxSnapIndex();
                prev.attr('disabled', index <= 0);
                next.attr('disabled', index >= max);
            }

            function getSnapIndex() {
                const listLeft = list[0].getBoundingClientRect().left;
                const itemOffsets = Array.from(items.map((i, node) => {
                    const itemLeft = node.getBoundingClientRect().left;
                    return Math.abs(itemLeft - listLeft);
                }));
                const minItemOffset = Math.min.apply(null, itemOffsets);
                const index = itemOffsets.indexOf(minItemOffset);
                return index;
            }

            function maxSnapIndex() {
                const listWidth = list[0].getBoundingClientRect().width;
                const scrollWidth = list[0].scrollWidth;
                const scrollLeft = list[0].scrollLeft;
                for (let k = items.length - 1; k >= 0; k--) {
                    let itemLeft = items[k].getBoundingClientRect().left;
                    let itemScrollDistance = scrollWidth - scrollLeft - itemLeft;
                    if (Math.floor(itemScrollDistance) > listWidth) {
                        return k + 1;
                    }
                }
                return 0;
            }
            
        });

    };

})(jQuery);
